import { ExtractHotels, LinkHotelsParams } from "@bandido/shared/interfaces";
import { client } from "../common/services";
import { useMutation, UseMutationOptions } from "react-query";
import { AxiosResponse } from "axios";



const extractoHotels = async ( params: ExtractHotels) =>
  client.post<boolean>(`content-extractor/extract-hotels`, params);

export const useExtractHotels = (
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<boolean, any>,
          unknown,
          ExtractHotels,
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => extractoHotels(data), options);



const linkHotels = async ( params: LinkHotelsParams) =>
  client.post<boolean>(`content-extractor/link-hotel`, params);

export const useLinkHotels = (
  options?:
    | Omit<
        UseMutationOptions<
          AxiosResponse<boolean, any>,
          unknown,
          LinkHotelsParams,
          unknown
        >,
        'mutationFn'
      >
    | undefined,
) => useMutation((data) => linkHotels(data), options);
